import { SortLabels } from "../../UI/Table/TableColumnHeader.tsx";

export const DATE_SORT_LABELS: SortLabels = {
  asc: "Dalla meno recente",
  desc: "Dalla più recente",
};

export const ALPHABETICAL_SORT_LABELS: SortLabels = {
  asc: "A → Z",
  desc: "Z → A",
};

export const COUNT_SORT_LABELS: SortLabels = {
  asc: "Dal più basso",
  desc: "Dal più alto",
};
